var _defs, _path, _path2, _polyline, _line;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDragRight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 24 24",
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".drag-right-icon{fill:none;stroke:#343a40;stroke-miterlimit:10;stroke-width:1px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "drag-right-icon",
    d: "M8.2,22.45,3.09,17.34a2,2,0,0,1,2.85-2.85L7.25,15.8V6.41A2,2,0,0,1,9,4.41,1.91,1.91,0,0,1,11.05,6.3V12l5,.72A1.9,1.9,0,0,1,17.7,14.6h0a17.16,17.16,0,0,1-1.81,7.67l-.09.18"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "drag-right-icon",
    d: "M11.05,10.65a4.4,4.4,0,0,0,1.46-1,4.75,4.75,0,1,0-6.72,0,4.4,4.4,0,0,0,1.46,1"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "drag-right-icon",
    points: "18.65 3.45 21.5 6.3 18.65 9.15"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "drag-right-icon",
    x1: 13.9,
    y1: 6.3,
    x2: 21.5,
    y2: 6.3
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragRight);
export default __webpack_public_path__ + "static/media/drag-right.18fce629.svg";
export { ForwardRef as ReactComponent };